module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 519
// module chunks = 0